import { render, staticRenderFns } from "./Promt.vue?vue&type=template&id=6ba88e14"
import script from "./Promt.vue?vue&type=script&lang=js"
export * from "./Promt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports